import { useMemo } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend, Title } from 'chart.js';
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend, Title);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: true, position: 'top' as const },
        title: { display: true, text: 'Total Price by Hour' },
    },
    scales: {
        x: { title: { display: true, text: 'Hour' } },
        y: { title: { display: true, text: 'Total Price' } },
    },
};

const BarChart = ({ bookings }: { bookings: any[] }) => {
    const chartData = useMemo(() => {
        const slotsByTimeRange: Record<string, number> = {};

        bookings.forEach((booking: any) => {
            booking.slots.forEach((slot: { from_time: string; to_time: string; price: any }) => {
                const timeRange = `${slot.from_time} - ${slot.to_time}`;
                slotsByTimeRange[timeRange] = (slotsByTimeRange[timeRange] || 0) + parseFloat(slot.price);
            });
        });

        return {
            labels: Object.keys(slotsByTimeRange),
            datasets: [{
                label: 'Total Price by Hour',
                data: Object.values(slotsByTimeRange),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            }],
        };
    }, [bookings]);

    return (
        <div className="w-full rounded-xl border bg-card p-3 lg:p-4">
            <p className="text-base lg:text-lg font-semibold">Revenue By Slots</p>
            <div className="mt-3 h-72 lg:h-80">
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

export default BarChart;
